<template>
  <v-btn
    text
    color="primary"
    :disabled="!isPending"
    @click="goTo()"
  >
    visualizar sugestões
    <v-icon>
      mdi-arrow-right
    </v-icon>
  </v-btn>
</template>

<script>
import RouterMixin from '@/app/arch/mixins/RouterMixin';
import LocalSessionMixin from '@/app/arch/mixins/LocalSessionMixin';

export default {
  name: 'ConciliationViewColumn',
  mixins: [RouterMixin, LocalSessionMixin],
  props: {
    value: {
      type: String,
      default: '',
    },
    row: {
      type: Object,
      default() {
        return {
          statusConciliation: '',
        };
      },
    },
  },
  computed: {
    getId() {
      return this.value;
    },
    isPending() {
      return this.row.statusConciliation === 'Pending';
    },
  },
  methods: {
    goTo() {
      this.setSessionItem('conciliationTransfer', this.row);
      this.navigateTo(
        'conciliation.edit',
        {
          id: this.getId,
          conciliation: this.row,
        },
      );
    },
  },
};
</script>
